import {
    Grid,
} from "@mui/material";
import DialogFullScreen from "../../../../../../components/DialogFullScreen";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import CardNotaFiscal from "./CardNotaFiscal";
import { IDetalheHistoricoMercadoria } from "../../../../../../types/api/estoque/detalhe-historico-mercadoria";
import CardProdutos from "./CardProdutos";
import CardDivergencias from "./CardDivergencias";
export default function DialogDetalheHistoricoRecebimento({ open, value, handleClose }: { open: boolean; value: string; handleClose: () => void }) {

    const { data, isLoading } = useQuery<IDetalheHistoricoMercadoria>({
        queryKey: ["detalhe-entrada-mercadoria"],
        queryFn: async () => {
            if (!open) return undefined as any;
            const res = await axiosClient.get(`/estoque/entrada-mercadorias/detalhar-entrada/${value}`);
            return res.data;
        },
        enabled: !!open && !!value,
        cacheTime: 0,
    });

    return (
        <DialogFullScreen open={open} handleClose={handleClose} title="Detalhe do recebimento">
            {isLoading && <LoadingApiQuery />}
            {!isLoading && data && (
                <>
                    <Grid container spacing={2}>
                        <Grid size={{xs: 12}}>
                            <CardNotaFiscal {...{ data }} />
                        </Grid>
                        {
                            data.status === 'Análise de divergência' &&
                            <Grid size={{xs: 12}}>
                                <CardDivergencias {...{ data }} />
                            </Grid>
                        }
                        <Grid size={{xs: 12}}>
                            <CardProdutos {...{ data }} />
                        </Grid>
                    </Grid>
                </>
            )}
        </DialogFullScreen>
    );
}